const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectTypeCircleSoilCarbon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#FF865D",
    style: {
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16089 16.1125H10.7415M20.5883 16.1125H25.0641M8.05605 23.2828L8.065 23.2729M10.7415 19.7021L10.7505 19.6923M13.427 23.2828L13.436 23.2729M16.1125 19.7021L16.1215 19.6923M18.798 23.2828L18.8069 23.2729M21.4835 19.7021L21.4924 19.6923M24.169 23.2828L24.1779 23.2729M13.427 17.0077C13.427 17.0077 14.2327 13.6589 16.1125 11.6367",
    stroke: "#FF865D",
    style: {
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.86 7.37676L20.1947 10.8589C20.4123 13.1174 18.7186 15.1289 16.4601 15.3455C14.2446 15.5585 12.2368 13.9392 12.0237 11.7228C11.9212 10.6587 12.2456 9.59749 12.9255 8.77256C13.6053 7.94763 14.5851 7.42656 15.6491 7.32394L19.3614 6.96588C19.4211 6.96008 19.4815 6.96614 19.5389 6.98371C19.5964 7.00128 19.6498 7.03001 19.6961 7.06827C19.7424 7.10652 19.7808 7.15354 19.8089 7.20663C19.837 7.25972 19.8543 7.31784 19.86 7.37765",
    stroke: "#FF865D",
    style: {
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCircleSoilCarbon);
export default __webpack_public_path__ + "static/media/project-type-circle-soil-carbon.00afe2e30be82c262e93da0fd8f99762.svg";
export { ForwardRef as ReactComponent };